import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Conditions from "../../Components/Conditions/Conditions";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import Alert from "../../Components/Alert/Alert";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";

export default function Login() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl()
  const [loginPhoneNumber, setLoginPhoneNumber] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [sendVerificationCode, setSendVerificationCode] = useState(false);
  const handlePhoneNumberChange = (event) => {
    setLoginPhoneNumber(event.target.value);
  };

  const handlePhoneNumberKeyUp = (event) => {
    if (event.which !== 8) {
      if (loginPhoneNumber.length == 2 || loginPhoneNumber.length == 6) {
        setLoginPhoneNumber((prevPhoneNumber) => prevPhoneNumber + " ");
      }
    }
  };

  const showConditionsHandler = () => {
    setShowConditions(true);
  };

  const hideConditionsHandler = () => {
    setShowConditions(false);
  };

  const handleLoginContinue = async () => {
    setSendVerificationCode(true);
    if (!isChecked) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("برای ادامه باید قوانین و مقررات را بپذیرید!");
      return;
    }
    if (loginPhoneNumber.length == 11 && isChecked) {
      try {
        const response = await Axios.post(
          `${baseUrl}/check_number`,
          {
            username: `09${loginPhoneNumber.replace(/\s/g, "")}`,
            first_name: "",
            last_name: "",
            latin_name: "",
          }
        );
        const data = response.data;
        if (data.send_code) {
          localStorage.setItem(
            "userPhoneNumber",
            `09${loginPhoneNumber.replace(/\s/g, "")}`
          );
          setShowAlert(true);
          setAlertText("در حال ارسال کد...");
          setTimeout(() => {
            setShowAlert(false);
            navigate("/verificationCode", {
              state: { mobileNumber: loginPhoneNumber, wait: data.wait },
            });
          }, 2000);
        }
      } catch (error) {
        console.error("Error during the API request:", error);
      }
    }
  };

  const acceptConditions = () => {
    setIsChecked(!isChecked);
    if (!isChecked) {
      setShowConditions(true);
    }
  };

  return showConditions ? (
    <Conditions onHide={hideConditionsHandler} />
  ) : (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="loginWrapper centeredFlex">
            <div className="loginTop">
              <h3>ورود</h3>
              <h6>جهت دریافت کد فعالسازی، شماره موبایل خود را وارد کنید</h6>
              <PhoneInput
                sendVerificationCode={sendVerificationCode}
                loginPhoneNumber={loginPhoneNumber}
                onNumberChange={(event) => handlePhoneNumberChange(event)}
                onNumberKeyUp={(event) => handlePhoneNumberKeyUp(event)}
              />
            </div>
            <div className="loginBottom centeredFlex">
              <button className="mainBtn" onClick={handleLoginContinue}>
                ادامه
              </button>
              <label className="customRadioContainer responsiveWidth loginCustomCondition">
                <input
                  type="checkbox"
                  className="radioBtn"
                  checked={isChecked}
                  onChange={acceptConditions}
                />
                <div className="customRadioBtn centeredFlex"></div>
                <div className="conditionText">
                  با ورود به رِدرُز شما
                  <span
                    className="conditionsLink"
                    onClick={showConditionsHandler}
                  >
                    شرایط و قوانین
                  </span>
                  استفاده از این برنامه را می‌پذیرید
                </div>
              </label>
            </div>
          </div>
          <Alert
            showAlert={showAlert}
            alertText={alertText}
            bottom={window.innerWidth < 767 ? "7.5rem" : "6.25rem"}
          />
        </div>
      </div>
    </div>
  );
}
